import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { Svg, Path } from 'react-native-svg';

import { Color } from '~/components/color';

import { IconProps } from './icon-types';

export const ArrowForwardIcon: FunctionComponent<IconProps> = ({ fill, size = 24 }) => {
    return (
        <View style={{ width: size, height: size }}>
            {/* @ts-ignore see https://github.com/react-native-svg/react-native-svg/issues/1471 */}
            <Svg accessibilityRole="image" viewBox="0 0 24 24" focusable={false} tabIndex="-1">
                <Path d="M20 12L3 12" stroke={fill ?? Color.ALMOST_BLACK} strokeWidth="2" />
                <Path
                    d="M14 6L20 12L14 18"
                    fill={Color.TRANSPARENT}
                    stroke={fill ?? Color.ALMOST_BLACK}
                    strokeWidth="2"
                />
            </Svg>
        </View>
    );
};
